import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import classNames from "classnames";

import { cardsData } from "../../helpers/service-card-data";
import { RequestInput } from "./request-input-box";
import { useRequestContext } from "../../services/requests/request.context";
import { LoadingIndicator } from "../utils/loader";
import { SiteAlert } from "../utils/alert";

export const CleanerRequestForm = () => {

    const cleaningType = useLocation().state;

    const [requestData, setRequestData] = useState({
        areaCode: '',
        cleanDate: '',
        cleanTime: '',
        cleanType: '',
        numCleaners: '',
        cleanerHours: '',
        cleanHours: '',
        phoneNumber: '',
        email: ''
    });
    const [onAlert, setOnAlert] = useState();

    const { isLoading, createNewRequest } = useRequestContext();

    const [emptyArray, setEmptyArray] = useState([]);



    const { areaCode, cleanDate, cleanTime, numCleaners, cleanerHours, cleanHours, phoneNumber, email } = requestData;



    useEffect(() => {
        const totHours = parseInt(numCleaners) * parseFloat(cleanerHours)
        setRequestData((d) => ({ ...d, cleanType: cleaningType }));
        setRequestData((data) => ({ ...data, cleanHours: totHours }))
    }, [cleaningType, cleanerHours, numCleaners])


    const detectEmptyData = () => {
        const dataArray = Object.keys(requestData);
        const empty = dataArray.filter((key) => (
            requestData[key] === '' || requestData[key] === null
        ));
        setEmptyArray(empty);
        return empty;
    }


    const handleInput = (e) => {
        setRequestData((data) => ({
            ...data,
            [e.target.name]: e.target.value
        }))
    }

    const handleSubmitData = async () => {
        const incomplete = detectEmptyData();
        if (incomplete.length > 0) return;
        const resp = await createNewRequest(requestData);
        if (resp?.error) handleAlert(resp, "Fehler")
        else handleAlert(resp, 'Erfolg');
        //console.log(requestData);
    }

    const handleAlert = (msg, caption) => {
        setOnAlert({
            caption: caption,
            message: msg.error ? msg?.error : msg.message,
            accept: 'OK',
            onAccept: () => {
                setOnAlert();
                window.location.reload();
            }
        })
    }

    return (
        <div className="flx-col c-al c-jt form-container">
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <SiteAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAccept={onAlert.onAccept}
                    onClose={() => setOnAlert()}
                />
            )}
            <form
                className="req-form"
                onSubmit={async (e) => {
                    e.preventDefault();
                    await handleSubmitData();
                }}
            >

                <RequestInput
                    type="number"
                    name="areaCode"
                    value={areaCode}
                    onChange={(e) => handleInput(e)}
                    isInvalid={emptyArray.includes('areaCode')}
                    caption={"Geben Sie Ihre Postleitzahl ein"}
                />
                <div className="flx-rw bt-jt req-input wrap-box">
                    <RequestInput
                        type="date"
                        name="cleanDate"
                        caption={"Wunschtermin für die Reinigung"}
                        value={cleanDate}
                        isInvalid={emptyArray.includes("cleanDate")}
                        onChange={(e) => handleInput(e)}
                    />
                    <RequestInput
                        type="time"
                        name="cleanTime"
                        caption={"Zeit"}
                        value={cleanTime}
                        isInvalid={emptyArray.includes("cleanTime")}
                        onChange={(e) => handleInput(e)}
                    />
                </div>
                <div className="flx-rw c-al req-input">
                    <label htmlFor="cleanType" className="req-caption">Art der Reinigung</label>
                    <select
                        name="cleanType"
                        className={classNames(
                            "form-input select-input",
                            { 'invalid': emptyArray.includes('cleanType') }
                        )}
                        defaultValue={cleaningType ? cleaningType : ''}
                        defaultChecked
                        onChange={(e) => handleInput(e)}
                    >
                        <option value={''}>
                            -- Reinigungsart auswählen --
                        </option>
                        {cardsData.map((data, index) => {
                            return (
                                <option
                                    value={data.title}
                                    key={index}
                                >
                                    {data.title}
                                </option>
                            )
                        })}
                    </select>

                </div>
                <RequestInput
                    type="number"
                    name="numCleaners"
                    caption={"Anzahl der benötigten Reinigungskräfte"}
                    value={numCleaners}
                    onChange={(e) => handleInput(e)}
                    isInvalid={emptyArray.includes("numCleaners")}
                />

                <RequestInput
                    type="number"
                    name="cleanerHours"
                    caption={"Anzahl der Stunden pro Reinigungskraft"}
                    value={cleanerHours}
                    onChange={(e) => handleInput(e)}
                    isInvalid={emptyArray.includes("numCleaners")}
                />

                <RequestInput
                    type="number"
                    name="cleanHours"
                    caption={"Gesamtreinigungsstunden"}
                    value={cleanHours}
                    onChange={(e) => handleInput(e)}
                    isInvalid={emptyArray.includes("cleanHours")}
                />
                <RequestInput
                    type="tel"
                    name="phoneNumber"
                    caption={"Geben Sie Ihre Telefonnummer ein"}
                    value={phoneNumber}
                    onChange={(e) => handleInput(e)}
                    isInvalid={emptyArray.includes("phoneNumber")}
                />

                <RequestInput
                    type="email"
                    name="email"
                    caption={"Geben Sie Ihre E-Mail-Adresse ein"}
                    value={email}
                    onChange={(e) => handleInput(e)}
                    isInvalid={emptyArray.includes("email")}
                />
                <div className="flx-rw c-al c-jt buttons-box">
                    <button
                        className="req-subm-button"
                    >
                        Senden Sie Ihre unverbindliche Anfrage.
                    </button>
                </div>
                {emptyArray.length > 0 && (
                    <div className="flx-rw c-al c-jt err-msg">
                        Bitte geben Sie alle erforderlichen Daten an!
                    </div>
                )}
            </form>
        </div>
    );
}